export const Arup = require('./arup.png');
export const Leeds = require('./leeds.png');
export const Pwc = require('./pwc.jpg');
export const Thermly = require('./thermly.png');